export enum locationTypes {
  HOME_OR_PRIMARY = "homeAndPrimaryString",
  CUSTOM_LOCATION = "customSalesLocationsString",
  SGF_LOCATION = "sgfLocationsString",
  OTHER_LOCATION = "otherLocationsString",
  PRODUCT_QUALITY_LOCATION = "productQualityLocationsString",
}
